import React from 'react';
export function SkinCare() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-542">
      <div className="max-w-[1800px] mx-auto" data-id="element-543">
        <header className="mb-20 text-center" data-id="element-544">
          <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-545">
            Natural Radiance
          </span>
          <h1 className="text-4xl md:text-6xl font-display font-bold tracking-[0.2em] uppercase mb-6" data-id="element-546">
            Coquette Skin Care
          </h1>
          <p className="max-w-xl mx-auto text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-547">
            Organic, botanical-based skin care inspired by traditional African
            beauty rituals.
          </p>
        </header>
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-548">
          <div className="aspect-square bg-grey-divider overflow-hidden" data-id="element-549">
            <img src="https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&q=80&w=800" className="w-full h-full object-cover" alt="Skin Care" data-id="element-550" />
          </div>
          <div className="space-y-6" data-id="element-551">
            <h2 className="text-2xl font-display font-bold tracking-widest uppercase" data-id="element-552">
              The Glow Serum
            </h2>
            <p className="text-sm font-light tracking-widest text-black/70 leading-relaxed uppercase" data-id="element-553">
              Infused with Baobab oil and Shea butter for deep nourishment and a
              natural, healthy glow.
            </p>
            <button className="border border-black px-10 py-4 text-[10px] font-display uppercase tracking-widest hover:bg-black hover:text-white transition-all" data-id="element-554">
              Coming Soon
            </button>
          </div>
        </div>
      </div>
    </div>;
}